import { createI18n } from 'vue-i18n';

const lang = localStorage.getItem('lang');

// Importar archivos base de idiomas
import esBase from './i18n/es.json';
import enBase from './i18n/en.json';

// Importar automáticamente todos los archivos de idioma usando import.meta.glob
// Esto cargará todos los archivos con patrón *.es.json y *.en.json de forma recursiva
const esModules = import.meta.glob('./i18n/**/*.es.json', { eager: true });
const enModules = import.meta.glob('./i18n/**/*.en.json', { eager: true });

// Función para combinar todos los módulos de idioma en un solo objeto
function mergeMessages(modules, baseMessages = {}) {
  const messages = { ...baseMessages };

  for (const path in modules) {
    const module = modules[path];
    const content = module.default || module;

    // Combinar el contenido del módulo en el objeto de mensajes
    Object.assign(messages, content);
  }

  return messages;
}

// Combinar todos los mensajes de español e inglés (incluyendo archivos base)
const es = mergeMessages(esModules, esBase);
const en = mergeMessages(enModules, enBase);

const i18n = createI18n({
  legacy: false,
  locale: lang ? lang : 'es',
  fallbackLocale: lang ? lang : 'es',
  messages: {
    es,
    en
  }
});

export { i18n };